<div class="container">
  <div class="row">
    <div class="col-md-12">
      <h1 class="mat-headline-medium" i18n>Sign in</h1>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-sm-12 col-md-6">
      <h2 class="mat-h2" i18n>E-Mail and password</h2>
      @if(signInForm) {
      <form
        [formGroup]="signInForm"
        class="d-flex flex-column"
        (ngSubmit)="trySignIn(signInForm.value)"
        (submit)="trySignIn(signInForm.value)"
      >
        <mat-form-field appearance="outline">
          <mat-label>E-Mail</mat-label>
          <input matInput type="email" formControlName="email" />
          <mat-error *ngIf="emailFieldHasError" i18n
            >This E-Mail address is not valid!</mat-error
          >
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Password</mat-label>
          <input matInput type="password" formControlName="password" />
          <mat-error *ngIf="passwordFieldHasError" i18n
            >The password field is empty!</mat-error
          >
        </mat-form-field>

        <div *ngIf="signInError" class="mt-3 alert alert-danger" color="">
          {{ signInError }}
        </div>

        <div class="mt-3 d-flex flex-row-reverse justify-content-between">
          <button
            mat-raised-button
            type="submit"
            color="accent"
            (click)="trySignIn(signInForm.value)"
            i18n
          >
            Sign in
          </button>
          <button mat-stroked-button routerLink="/forgot-password" i18n>
            Forgot password
          </button>
        </div>
      </form>
      }
    </div>
    <div class="col-sm-12 d-md-none">
      <mat-divider class="mt-3 mb-3"></mat-divider>
    </div>
    <div class="col-md-3">
      <h3 class="mat-h2 text-center d-none d-md-block" i18n>OAuth providers</h3>
      <p class="mat-body text-center" i18n>You can also sign in with:</p>
      <div class="oauth-buttons d-flex flex-column align-items-center">
        <button mat-flat-button color="warn" (click)="trySignInGoogle()">
          Google
        </button>
        <!-- <button mat-flat-button disabled color="accent">Twitter</button>
        <button mat-flat-button disabled color="primary">Github</button> -->
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-md-9 text-center mb-5">
      <mat-divider class="mt-4 mb-3"></mat-divider>
      <p class="mat-body" i18n>
        Don't have an account yet? Simply sign in with your Google account or
        sign up below.
      </p>
      <button mat-stroked-button routerLink="/sign-up" color="accent" i18n>
        Sign up here
      </button>
    </div>
  </div>
</div>
